import { render, staticRenderFns } from "./cookie-modal.vue?vue&type=template&id=627d71c2&scoped=true&"
import script from "./cookie-modal.vue?vue&type=script&lang=ts&"
export * from "./cookie-modal.vue?vue&type=script&lang=ts&"
import style0 from "./cookie-modal.vue?vue&type=style&index=0&id=627d71c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627d71c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCard,VDialog,VDivider,VIcon,VRow,VSwitch})
